import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/components/Index';
import store from '@/vuex/store';
import {getToken} from '@/utils/auth';

const Login = resolve => require(['@/components/Login'], resolve);
const SignUp = resolve => require(['@/components/SignUp'], resolve);
const CheckPhone = resolve => require(['@/components/signUp/CheckPhone'], resolve);
const InputInfo = resolve => require(['@/components/signUp/InputInfo'], resolve);
const SignUpDone = resolve => require(['@/components/signUp/SignUpDone'], resolve);
const GoodsList = resolve => require(['@/components/GoodsList'], resolve);
const GoodsDetail = resolve => require(['@/components/GoodsDetail'], resolve);
const ShoppingCart = resolve => require(['@/components/ShoppingCart'], resolve);
const Order = resolve => require(['@/components/Order'], resolve);
const Pay = resolve => require(['@/components/Pay'], resolve);
const PayDone = resolve => require(['@/components/PayDone'], resolve);
const Freeback = resolve => require(['@/components/Freeback'], resolve);
const Home = resolve => require(['@/components/Home'], resolve);
const MyAddress = resolve => require(['@/components/home/MyAddress'], resolve);
const AddAddress = resolve => require(['@/components/home/AddAddress'], resolve);
const MyOrder = resolve => require(['@/components/home/MyOrder'], resolve);
const MyShoppingCart = resolve => require(['@/components/home/MyShoppingCart'], resolve);
const Merchant = resolve => require(['@/components/Merchant'], resolve);
const Quotes = resolve => require(['@/components/quotes'], resolve);
const Realtime = resolve => require(['@/components/realtime'], resolve);
const RealtimeDetail = resolve => require(['@/components/realtimeDetail'], resolve);
const Pricedetails = resolve => require(['@/components/Pricedetails'], resolve);
const Exportdata = resolve => require(['@/components/Exportdata'], resolve);
const CityPartner = resolve => require(['@/components/cityPartner'], resolve);
const price = resolve => require(['@/components/price'], resolve);
const findGoods = resolve => require(['@/components/FindGoods'], resolve);
const marketquotations = resolve => require(['@/components/marketquotations'], resolve);
const researchreport = resolve => require(['@/components/researchreport'], resolve);
const broker = resolve => require(['@/components/broker'], resolve);
const supplyanddemand = resolve => require(['@/components/supplyanddemand'], resolve);
const Spotmall = resolve => require(['@/components/Spotmall'], resolve);
const Company = resolve => require(['@/components/Company'], resolve);
const PersonalCenter = resolve => require(['@/components/personalCenterComponents/PersonalCenter.vue'], resolve);
const PersonalCenterBuyerSupply = resolve => require(['@/components/personalCenterComponents/PersonalCenter-buyerSupply.vue'], resolve);
const PersonalCenterPurchaseMessage = resolve => require(['@/components/personalCenterComponents/PersonalCenterPurchaseMessage.vue'], resolve);
const PersonalCenterBrokerInfo = resolve => require(['@/components/personalCenterComponents/PersonalCenterBrokerInfo.vue'], resolve);
const accounts = resolve => require(['@/components/account/accounts'], resolve);
const CompanyInfo = resolve => require(['@/components/account/CompanyInfo'], resolve);
const PersonalInfo = resolve => require(['@/components/account/PersonalInfo'], resolve);
const PersonalPassword = resolve => require(['@/components/account/ChangePassword'], resolve);
const Personalforgotpassword = resolve => require(['@/components/account/forgotpassword'], resolve);
const PersonalFixpassword = resolve => require(['@/components/account/Fixpassword'], resolve);
const Personalsuccess = resolve => require(['@/components/account/success'], resolve);
const register = resolve => require(['@/components/Information/register'], resolve);
const complete = resolve => require(['@/components/Information/complete'], resolve);
const cart = resolve => require(['@/components/cart/cart.vue'], resolve);

Vue.use(Router);
const routes = [
  {
    path: '/', // 首页
    name: 'Index',
    component: Index
  },
  // {
  //   path: '/Login', // 登录
  //   name: 'Login',
  //   component: Login
  // },
  {
    path: '/SignUp', // 注册
    name: 'SignUp',
    component: SignUp,
    children: [
      {
        path: '/',
        name: 'index',
        component: CheckPhone
      },
      {
        path: 'checkPhone',
        name: 'CheckPhone',
        component: CheckPhone
      },
      {
        path: 'inputInfo',
        name: 'InputInfo',
        component: InputInfo
      },
      {
        path: 'signUpDone',
        name: 'SignUpDone',
        component: SignUpDone
      }
    ]
  },
  {
    path: '/goodsList', // 商品列表
    name: 'GoodsList',
    component: GoodsList
  },
  {
    path: '/goodsDetail', // 商品详情
    name: 'GoodsDetail',
    component: GoodsDetail,
    meta: {
      belong: '现货商城'
    }
  },
  {
    path: '/shoppingCart', // 商品详情
    name: 'ShoppingCart',
    component: ShoppingCart
  },
  {
    path: '/order', // 订单页面
    name: 'Order',
    component: Order
  },
  {
    path: '/pay', // 支付页面
    name: 'Pay',
    component: Pay
  },
  {
    path: '/payDone', // 支付成功页面
    name: 'PayDone',
    component: PayDone
  },
  {
    path: '/freeback', // 反馈页面
    name: 'Freeback',
    component: Freeback
  },
  {
    path: '/home', // 主页
    name: 'Home',
    component: Home,
    children: [
      {
        path: '/',
        name: 'HomeIndex',
        component: MyOrder
      },
      {
        path: 'myAddress',
        name: 'MyAddress',
        component: MyAddress
      },
      {
        path: 'addAddress',
        name: 'AddAddress',
        component: AddAddress
      },
      {
        path: 'myOrder',
        name: 'MyOrder',
        component: MyOrder
      },
      {
        path: 'myShoppingCart',
        name: 'MyShoppingCart',
        component: MyShoppingCart
      }
    ]
  },
  {
    path: '/merchant',
    name: 'Merchant',
    component: Merchant
  },
  // 资讯
  {
    path: '/Realtime',
    name: 'Realtime',
    component: Realtime
  },
  // 资讯-详情
  {
    path: '/RealtimeDetail',
    name: 'RealtimeDetail',
    component: RealtimeDetail
  },
  {
    path: '/RealtimePricedetails',
    name: 'RealtimePricedetails',
    component: Pricedetails,
    meta: {
      belong: '资讯'
    }
  },
  // 实时行情
  {
    path: '/Quotes',
    name: 'Quotes',
    component: Quotes
  },
  // 数据
  {
    path: '/Exportdata',
    name: 'Exportdata',
    component: Exportdata
  },
  // 数据-详情
  {
    path: '/ExportdataPricedetails',
    name: 'ExportdataPricedetails',
    component: Pricedetails,
    meta: {
      belong: '数据'
    }
  },
  // 城市合伙人
  {
    path: '/CityPartner',
    name: 'CityPartner',
    component: CityPartner
  },
  // 价格
  {
    path: '/price',
    name: 'price',
    component: price,
  },
  // 价格
  {
    path: '/FindGoods',
    name: 'FindGoods',
    component: findGoods,
  },

  //价格-详情
  {
    path: '/Pricedetails',
    name: 'Pricedetails',
    component: Pricedetails,
    meta: {
      belong: '价格'
    }
  },
  // 行情
  {
    path: '/marketquotations',
    name: 'marketquotations',
    component: marketquotations,
  },

  //行情-详情
  {
    path: '/marketquotatimetePricedetails',
    name: 'marketquotatimetePricedetails',
    component: Pricedetails,
    meta: {
      belong: '行情'
    }
  },
  //研究报告
  {
    path: '/researchreport',
    name: 'researchreport',
    component: researchreport,
  },
  //研究报告-详情
  {
    path: '/researchreportPricedetails',
    name: 'researchreportPricedetails',
    component: Pricedetails,
    meta: {
      belong: '研究报告'
    }
  },
  //经纪人
  {
    path: '/broker',
    name: 'broker',
    component: broker,
  },
  //供求信息
  {
    path: '/supplyanddemand',
    name: 'supplyanddemand',
    component: supplyanddemand,
  },
  //现货商城
  {
    path: '/Spotmall',
    name: 'Spotmall',
    component: Spotmall,
  },
  //企业
  {
    path: '/Company',
    name: 'Company',
    component: Company,
  },
  // 收货地址管理
  {
    path: '/PersonalReceiveAddress',
    name: 'PersonalReceiveAddress',
    component: () => import('@/components/hm_personal/ReceiveAddress')
  },
  //订单详情
  {
    path: '/PersonalOrderDetail',
    name: 'PersonalOrderDetail',
    component: () => import('@/components/hm_personal/OrderDetail')
  },
  // 销售订单详情
  {
    path: '/PersonalSellerOrderDetail',
    name: 'PersonalSellerOrderDetail',
    component: () => import('@/components/hm_personal/SellerOrderDetail')
  },
  // 商品管理
  {
    path: '/PersonalCommodityManagement',
    name: 'PersonalCommodityManagement',
    component: () => import('@/components/hm_personal/CommodityManagement')
  },
  // 新增商品
  {
    path: '/PersonalAddCommodity',
    name: 'PersonalAddCommodity',
    component: () => import('@/components/hm_personal/AddCommodity')
  },
  // 卖家销售订单
  {
    path: '/PersonalSaleOrder',
    name: 'PersonalSaleOrder',
    component: () => import('@/components/hm_personal/SaleOrder')
  },
  // 登录
  {
    path: '/UserLogin',
    name: 'UserLogin',
    component: () => import('@/components/hm_personal/Login')
  },
  // 商品管理-新增商品
  {
    path: '/PersonalAddProduct',
    name: 'PersonalAddProduct',
    component: () => import('@/components/sellerStoreMange/add')
  },
  // 商品管理-商品详情
  {
    path: '/PersonalProductDetail',
    name: 'PersonalProductDetail',
    component: () => import('@/components/sellerStoreMange/detail')
  },
  // 店铺管理-更新店铺
  {
    path: '/PersonalStoreInfo',
    name: 'PersonalStoreInfo',
    component: () => import('@/components/sellerStoreMange/info')
  },
  //售后管理
  {
    path: '/PersonalAfterSalesManagement',
    name: 'PersonalAfterSalesManagement',
    component: () => import('@/components/hm_personal/AfterSalesManagement')
  },
  //售后管理-详情
  {
    path: '/PersonalAfterSalesDetail',
    name: 'PersonalAfterSalesDetail',
    component: () => import('@/components/hm_personal/AfterSalesDetail')
  },
  //发票管理
  {
    path: '/PersonalInvoiceManagement',
    name: 'PersonalInvoiceManagement',
    component: () => import('@/components/hm_personal/InvoiceManagement')
  },
  //发票管理-详情
  {
    path: '/PersonalInvoiceDetail',
    name: 'PersonalInvoiceDetail',
    component: () => import('@/components/hm_personal/InvoiceDetail')
  },
  //合同管理
  {
    path: '/PersonalContractManagement',
    name: 'PersonalContractManagement',
    component: () => import('@/components/hm_personal/ContractManagement')
  },
  //交易评价
  {
    path: '/PersonalEvaluationList',
    name: 'PersonalEvaluationList',
    component: () => import('@/components/hm_personal/EvaluationList')
  },
  //交易评价-详情
  {
    path: '/PersonalEvaluationDetail',
    name: 'PersonalEvaluationDetail',
    component: () => import('@/components/hm_personal/EvaluationDetail')
  },
  //商家设置-物流公司
  {
    path: '/PersonalMerchantManagement',
    name: 'PersonalMerchantManagement',
    component: () => import('@/components/hm_personal/MerchantManagement')
  },
  //商家设置-物流配置
  {
    path: '/PersonalLogisticsSetup',
    name: 'PersonalLogisticsSetup',
    component: () => import('@/components/hm_personal/LogisticsSetup')
  },

  //仓库管理 -仓库列表
  {
    path: '/PersonalWarehouseManagement',
    name: 'PersonalWarehouseManagement',
    component: () => import('@/components/hm_personal/WarehouseManagement')
  },
  //仓库管理 -详情
  {
    path: '/PersonalWarehouseDetail',
    name: 'PersonalWarehouseDetail',
    component: () => import('@/components/hm_personal/WarehouseDetail')
  },
  //物流调拨 - 配送列表
  {
    path: '/PersonalLogisticsManagement',
    name: 'PersonalLogisticsManagement',
    component: () => import('@/components/hm_personal/LogisticsManagement')
  },
  //物流调拨 -详情
  {
    path: '/PersonalLogisticsDetail',
    name: 'PersonalLogisticsDetail',
    component: () => import('@/components/hm_personal/LogisticsDetail')
  },
  //商家统计
  {
    path: '/PersonalBusinessStatistics',
    name: 'PersonalBusinessStatistics',
    component: () => import('@/components/hm_personal/BusinessStatistics')
  },
  //  赊销额度查询列表
  {
    path: '/PersonalCreditLimitInquiryList',
    name: 'PersonalCreditLimitInquiryList',
    component: () => import('@/components/creditLimitInquiry/creditLimitInquiryList'),
    meta: {
      title: '赊销额度查询'
    },
  },
  //  总额度变更历史
  {
    path: '/PersonalcreditLimitInquiryAllList',
    name: 'PersonalcreditLimitInquiryAllList',
    component: () => import('@/components/creditLimitInquiry/creditLimitInquiryAllList'),
    meta: {
      title: '总额度变更历史'
    },
  },
  //  赊销额度提升列表
  {
    path: '/PersonalIncreaseInCreditSalesLimitList',
    name: 'PersonalIncreaseInCreditSalesLimitList',
    component: () => import('@/components/increaseInCreditSalesLimit/increaseInCreditSalesLimitList'),
    meta: {
      title: '赊销额度提升'
    },
  },
  //  赊销额度提升详情
  {
    path: '/PersonalIncreaseInCreditSalesLimitDetail',
    name: 'PersonalIncreaseInCreditSalesLimitDetail',
    component: () => import('@/components/increaseInCreditSalesLimit/increaseInCreditSalesLimitDetail'),
    meta: {
      title: '提升申请详情'
    },
  },
  //  赊销额度申请列表
  {
    path: '/PersonalCreditSalesApplicationList',
    name: 'PersonalCreditSalesApplicationList',
    component: () => import('@/components/creditSalesApplication/creditSalesApplicationList'),
    meta: {
      title: '赊销额度申请'
    },
  },
  //  赊销额度申请详情
  {
    path: '/PersonalCreditSalesApplicationDetail',
    name: 'PersonalCreditSalesApplicationDetail',
    component: () => import('@/components/creditSalesApplication/creditSalesApplicationDetail'),
    meta: {
      title: '赊销申请详情'
    },
  },
  //  赊销订单管理
  {
    path: '/PersonalCreditOrderManagementList',
    name: 'PersonalCreditOrderManagementList',
    component: () => import('@/components/creditOrderManagement/creditOrderManagementList'),
    meta: {
      title: '订单列表'
    },
  },
  //  赊销订单管理详情
  {
    path: '/PersonalCreditOrderManagementDetail',
    name: 'PersonalCreditOrderManagementDetail',
    component: () => import('@/components/creditOrderManagement/creditOrderManagementDetail'),
    meta: {
      title: '订单详情'
    },
  },
  //  合同管理列表
  {
    path: '/PersonalContractManagementBackList',
    name: 'PersonalContractManagementBackList',
    component: () => import('@/components/contractManagementBack/contractManagementBackList'),
    meta: {
      title: '合同管理列表'
    },
  },
  //个人中心
  {
    path: '/PersonalCenter',
    name: 'PersonalCenter',
    component: PersonalCenter,
    meta: {
      title: '我的订单'
    }
  },
  //订单详情
  {
    path: '/PersonalCenterDetail',
    name: 'PersonalCenterDetail',
    component: () => import('@/components/personalCenterComponents/PersonalCenterDetail')
  },
  {
    path: '/PersonalCenterPay',
    name: 'PersonalCenterPay',
    component: () => import('@/components/personalCenterComponents/PersonalCenterPay'),
    meta: {
      title: '订单付款'
    }
  },
  {
    path: '/PersonalCenterEvaluate',
    name: 'PersonalCenterEvaluate',
    component: () => import('@/components/personalCenterComponents/PersonalCenterEvaluate'),
    meta: {
      title: '评价'
    }
  },
  // 供应信息
  {
    path: '/PersonalCenterBuyerSupply',
    name: 'PersonalCenterBuyerSupply',
    component: PersonalCenterBuyerSupply,
    meta: {
      title: '供应信息'
    }
  },
  // 求购信息
  {
    path: '/PersonalCenterPurchaseMessage',
    name: 'PersonalCenterPurchaseMessage',
    component: PersonalCenterPurchaseMessage,
    meta: {
      title: '求购信息'
    }
  },
  // 经纪人信息
  {
    path: '/PersonalCenterBrokerInfo',
    name: 'PersonalCenterBrokerInfo',
    component: PersonalCenterBrokerInfo,
    meta: {
      title: '经纪人信息'
    }
  },
  //账户安全
  {
    path: '/PersonalAccounts',
    name: 'PersonalAccounts',
    component: accounts,
  },
  //公司基本信息
  {
    path: '/PersonalCompanyInfo',
    name: 'PersonalCompanyInfo',
    component: CompanyInfo,
  },
  //个人基本信息
  {
    path: '/PersonalInfo',
    name: 'PersonalInfo',
    component: PersonalInfo,
  },
  //修改密码
  {
    path: '/PersonalPassword',
    name: 'PersonalPassword',
    component: PersonalPassword,
  },
  //忘记密码
  {
    path: '/Personalforgotpassword',
    name: 'Personalforgotpassword',
    component: Personalforgotpassword,
  },
  //设置新密码
  {
    path: '/PersonalFixpassword',
    name: 'PersonalFixpassword',
    component: PersonalFixpassword,
  },
  //密码重置成功success
  {
    path: '/Personalsuccess',
    name: 'Personalsuccess',
    component: Personalsuccess,
  },
  //注册
  {
    path: '/UserRegister',
    name: 'UserRegister',
    component: register,
  },
  //注册完成
  {
    path: '/UserComplete',
    name: 'UserComplete',
    component: complete,
  },
  //忘记密码
  {
    path: '/UserPassword',
    name: 'UserPassword',
    component: () => import('@/components/Information/password')
  },

  //我的求购订单
  {
    path: '/PersonalPurchaseOrder',
    name: 'PersonalPurchaseOrder',
    component: () => import('@/components/personalCenterComponents/PurchaseOrder'),
    meta: {
      title: '我的求购订单'
    }
  },
  // 我的求购订单详情
  {
    path: '/PersonalPurchaseOrderDetail',
    name: 'PersonalPurchaseOrderDetail',
    component: () => import('@/components/personalCenterComponents/PurchaseOrderDetail')
  },

  // 售后管理
  {
    path: '/PersonalPurchaseAfterSales',
    name: 'PersonalPurchaseAfterSales',
    component: () => import('@/components/personalCenterComponents/PersonalPurchaseAfterSales'),
    meta: {
      title: '售后管理'
    }
  },
  // 售后管理详情
  {
    path: '/PersonalPurchaseAfterSalesDetail',
    name: 'PersonalPurchaseAfterSalesDetail',
    component: () => import('@/components/personalCenterComponents/PersonalPurchaseAfterSalesDetail')
  },
  // 合同管理
  {
    path: '/PersonalPurchaseContract',
    name: 'PersonalPurchaseContract',
    component: () => import('@/components/personalCenterComponents/PersonalPurchaseContract'),
    meta: {
      title: '合同管理'
    }
  },
  // 发票管理
  {
    path: '/PersonalPurchaseInvoice',
    name: 'PersonalPurchaseInvoice',
    component: () => import('@/components/personalCenterComponents/PersonalPurchaseInvoice'),
    meta: {
      title: '申请开票'
    }
  },
  // 发票管理详情
  {
    path: '/PersonalPurchaseInvoiceDetail',
    name: 'PersonalPurchaseInvoiceDetail',
    component: () => import('@/components/personalCenterComponents/PersonalPurchaseInvoiceDetail')
  },

  // 收藏管理
  {
    path: '/PersonalPurchaseCollect',
    name: 'PersonalPurchaseCollect',
    component: () => import('@/components/personalCenterComponents/PersonalPurchaseCollect'),
    meta: {
      title: '收藏管理'
    }
  },

  // 我的资产
  {
    path: '/PersonalMyproperty',
    name: 'PersonalMyproperty',
    meta: {
      title: '我的资产'
    },
    component: () => import('@/components/personalCenterComponents/PersonalMyproperty')
  },

  // 我的消息
  {
    path: '/PersonalMymessage',
    name: 'PersonalMymessage',
    component: () => import('@/components/personalCenterComponents/PersonalMymessage'),
    meta: {
      title: '我的消息'
    }
  },

  // 我的留言
  {
    path: '/PersonalLeaveAmessage',
    name: 'PersonalLeaveAmessage',
    component: () => import('@/components/personalCenterComponents/PersonalLeaveAmessage'),
    meta: {
      title: '我的留言'
    }
  },

  // 实名认证
  {
    path: '/PersonalRealNameAuthentication',
    name: 'PersonalRealNameAuthentication',
    component: () => import('@/components/personalCenterComponents/PersonalRealNameAuthentication'),
    meta: {
      title: '实名认证'
    }
  },
  // 公司认证
  {
    path: '/PersonalCompanyAuth',
    name: 'PersonalCompanyAuth',
    component: () => import('@/components/personalCenterComponents/companyAuth.vue'),
    meta: {
      title: '公司认证'
    },
  },

  // 支付方式
  {
    path: '/Paymentmethod',
    name: 'Paymentmethod',
    component: () => import('@/components/quickLink/Paymentmethod'),
    meta: {
      title: '支付方式'
    },
  },

  //  消费者保障
  {
    path: '/Consumerprotection',
    name: 'Consumerprotection',
    component: () => import('@/components/quickLink/Consumerprotection'),
    meta: {
      title: '消费者保障'
    },
  },

  //  客服中心
  {
    path: '/Customerservicecenter',
    name: 'Customerservicecenter',
    component: () => import('@/components/quickLink/Customerservicecenter'),
    meta: {
      title: '客服中心'
    },
  },
  {
    path: '/cart', // 购物车
    name: 'cart',
    component: cart
  }
];
const router = new Router({
  mode: 'history',
  routes
});
router.beforeEach((to, from, next) => {
  // -----判断是否是用户中心相关页面-----是就使用用户中心子的header和nav侧边栏------
  // console.log(to, to.name.includes('personal') || to.name.includes('Personal'));
  // if (to.path.includes('Personal')) {
  //   // console.log(store);
  //   store.dispatch('toPersonalCenter', true)
  //   console.log(store,to.path)
  // } else if(to.path.includes('User')){
  //   console.log(to.path.includes('User'))
  //   //判断是否用户登录有关
  //   store.dispatch('toUserCenter', true)
  //   console.log(store,to.path)
  // }else{
  //   store.dispatch('toPersonalCenter', false)
  //   store.dispatch('toUserCenter', false)
  // }
  store.dispatch('toPersonalCenter', to.path.includes('Personal'));
  store.dispatch('toUserCenter', to.path.includes('User'));
  // if (to.path.includes('Personal')) {
  //   // console.log(store);
  //   store.dispatch('toPersonalCenter', true)
  // } else {
  //   store.dispatch('toPersonalCenter', false)
  // }
  if (getToken() && to.path.includes('Login')) {
    router.push('/');
  }

  // -------------------------------------------------------------------------------
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js